import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var MinerallyIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 60 60" }),
    React.createElement("circle", { cx: 30, cy: 30, r: 28, fill: "#131314" }),
    React.createElement("path", { d: "m30 16.18-5.86 2.24v23.5l5.74 3.99 5.98-3.99v-23.5l-5.86-2.24Zm-4.74 3.05 1.62-.62v23.88l-1.62-1.12V19.23Zm2.81 24V18.17l1.93-.75 1.81.69V43.3l-1.93 1.31-1.81-1.37Zm6.61-1.93-1.75 1.18V18.55l1.75.69v22.07Z", style: {
            fill: "#fff",
        } }))); };

export default MinerallyIcon;
